<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="d-flex justify-content-end">
              <div>
                <router-link to="/olevelstaffload"
                  ><b-button size="sm" variant="info" class="mx-4"
                    ><i class="mdi mdi-plus"></i>Add O'level Staff
                    Load</b-button
                  ></router-link
                >
              </div>
              <div>
                <b-button v-b-modal.new-staffload size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New A'level Staff Load</b-button
                >
              </div>
            </div>
            <br />
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(user)="data">
                  {{ data.item.user.full_name }}
                </template>
                <template #cell(subject)="data">
                  {{ data.item.subject.name }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(data.item.id, data.item.user.id, data.item.subject)
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="
                        remove(
                          data.item.id,
                          data.item.subject,
                          data.item.user.full_name,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="new-staffload"
      centered
      title="New Staff Load"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addStaffLoad">
        <div class="form-group mb-2">
          <label>Staff</label>
          <v-select
            :options="staffmembers"
            placeholder="Select User"
            label="full_name"
            v-model="user"
            :reduce="(staffmembers) => staffmembers.id"
          ></v-select>
          <label>Subject</label>
          <multiselect
            v-model="subject"
            label="name"
            :options="alevelsubjects"
          ></multiselect>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('new-staffload')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      id="edit-staffload"
      centered
      title="Edit Staff Load"
      title-class="font-14"
      hide-footer
    >
      <form @submit.prevent="editStaffLoad">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden" />
          <label>Staff</label>
          <v-select
            :options="staffmembers"
            placeholder="Select User"
            label="full_name"
            v-model="user"
            :reduce="(staffmembers) => staffmembers.id"
          ></v-select>
          <label>Subject</label>
          <multiselect
            v-model="subject"
            label="name"
            :options="alevelsubjects"
          ></multiselect>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('edit-staffload')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      id="delete-staffload"
      centered
      title="Delete Staff Load"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="removeStaffLoad">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Subject Teacher :
        <b>{{ user }}</b> for <b>{{ subject.name }} </b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('delete-staffload')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> YES</b-button
          >
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  alevelstaffloadComputed,
  alevelstaffloadMethods,
  alevelsubjectsComputed,
  alevelsubjectsMethods,
  staffmemberComputed,
  staffmemberMethods,
  userComputed,
  userMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "A'level Staff Load",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "A'level Staff Load",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "A'level Staff Load", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "user", label: "Staff", visible: true },
        { key: "subject", label: "Subject", visible: true },
        { key: "created_at", label: "Added On", visible: true },
        { key: "addedby", label: "Added By", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      subject: "",
      user: "",
      name: "",
      full_name: "",
      created_at: "",
    };
  },
  computed: {
    ...userComputed,
    ...alevelstaffloadComputed,
    ...alevelsubjectsComputed,
    ...staffmemberComputed,
    List() {
      return this.alevelstaffloads.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.alevelstaffloads.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.alevelstaffloads.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchAlevelSubjects();
    this.fetchUsers();
    this.fetchStaffMembers();
    this.fetchAlevelStaffloads();
    this.TotalRows = this.alevelstaffloads.length;
    this.isBusy = false;
  },
  methods: {
    ...userMethods,
    ...alevelsubjectsMethods,
    ...alevelstaffloadMethods,
    ...staffmemberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, user, subject) {
      this.id = id;
      this.subject = subject;
      this.user = user;
      this.$bvModal.show("edit-staffload");
    },
    remove(id, subject, user) {
      this.id = id;
      this.subject = subject;
      this.user = user;
      this.$bvModal.show("delete-staffload");
    },
    async addStaffLoad() {
      let formData = new FormData();
      formData.append("subject", this.subject.id);
      formData.append("user", this.user);
      let url = "/addalevelstaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchAlevelStaffLoads();
          this.$bvModal.hide("new-staffload");
          this.user = "";
          this.subject = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editStaffLoad() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("subject", this.subject.id);
      formData.append("user", this.user);
      let url = "/updatealevelstaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchAlevelStaffloads();
          this.$bvModal.hide("edit-staffload");
          this.user = "";
          this.subject = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeStaffLoad() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removealevelstaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchAlevelStaffloads();
          this.$bvModal.hide("delete-staffload");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
